const HERO_DEV_API_DOMAIN = 'api.smartgift-dev.net';
const HERO_PROD_API_DOMAIN = 'api.smartgift.com';

const SAFE_DOMAIN_LIST = [HERO_PROD_API_DOMAIN, HERO_DEV_API_DOMAIN];

export { HERO_DEV_API_DOMAIN, HERO_PROD_API_DOMAIN, SAFE_DOMAIN_LIST };
